<template>
  <input @input="input" type="email" :required="required" :id="id" :value="value" inputmode="email"
         class="input-base block w-full sm:leading-5 rounded-md" :class="$parent.inputClass"
         :placeholder="placeholder"/>

</template>

<script>

import {setup, mixin} from "@/components/ui/form/mixins/BaseInput";

export default {
  name: "UiFormEmail",
  setup: setup,
  mixins: [mixin],
}
</script>
